import { Component, OnInit, ViewChild } from '@angular/core';

declare var paypal: any;
import { render } from 'creditcardpayments/creditCardPayments';
import { Router } from '@angular/router';
import { StripeService, Elements, Element as StripeElement, ElementsOptions } from "ngx-stripe";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Http } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';
import { LoginService } from '../../login-service';
import { identifierModuleUrl } from '@angular/compiler';
@Component({
  selector: 'app-subcription',
  templateUrl: './subcription.component.html',
  styleUrls: ['./subcription.component.scss'],
  providers: [DatePipe]
})
export class SubcriptionComponent implements OnInit {
  @ViewChild('largeModal') public largeModal: ModalDirective;
  handler: any = null;
  success: boolean = false;
  payvalue: string;
  amount: any;
  dismissModal: boolean = false;
  elements: Elements;
  card: StripeElement;
  stripeTest: FormGroup;
  paystripe: boolean = false;
  // optional parameters
  elementsOptions: ElementsOptions = {
    locale: 'es'
  };
  showplandetails:boolean=false;
  subscriptionPlans: any;
  initiatorPlans: any;
  usertype: string;
  userID: any;
  usersList: any;
  currentUser: any;
  selectedPlan: any;
  collaboratorid: any;
  initiatorid: any;
  myDate = new Date();
  newDate = new Date();
  startdate: any;
  enddate: any;
  days: number;
  tabvalue: any;
  paymodal: boolean = false;
  subscriptionrowid: any;
  displayButtons:boolean=false;
  constructor(private router: Router,
    private http: Http,
    private fb: FormBuilder, private datePipe: DatePipe,
    private stripeService: StripeService, private loginService: LoginService, private activateRoute: ActivatedRoute) {
    this.userID = this.activateRoute.snapshot.params['userID'];
    this.tabvalue = this.activateRoute.snapshot.params['tabvalue'];
      this.subscriptionrowid=this.activateRoute.snapshot.params['subscriptionid'];
  }
  ngOnInit() {
console.log(this.tabvalue)
    this.GetSubscriptionplans();
    this.usertype = localStorage.getItem('SIGNEDUPAS')

    this.GetUsers();
    this.paystripe = false;
    this.stripeTest = this.fb.group({
      name: ['', [Validators.required]]
    });

  }

  addDate(days: any) {
    this.myDate = new Date();
    this.newDate = new Date();
    console.log(days)
    this.startdate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd hh:mm:ss');
    const enddate = new Date(this.myDate.setDate(this.myDate.getDate() + parseInt(days)));
    this.enddate = this.datePipe.transform(enddate, 'yyyy-MM-dd hh:mm:ss');
    console.log(this.startdate,this.enddate)

  }

  GetSubscriptionplans() {
    this.loginService.GetSubscriptionplans(1).subscribe(data => {
      data = JSON.parse(data['_body']);

      this.subscriptionPlans = data;

      this.GetUsers();


    })
  }
  GetUsers() {
    this.loginService.GetUsers(1).subscribe(data => {

      data = JSON.parse(data['_body']);
      this.usersList = JSON.parse(JSON.stringify(data));

      this.currentUser = this.usersList.filter(x => x.id == this.userID);

      let usertype = this.currentUser[0].user_type;

      if (usertype == 'Collaborator') {
        console.log("true");
      }
      this.initiatorPlans = this.subscriptionPlans.filter(x => x.user_type == usertype.toLowerCase() || x.user_type == 'both' || x.user_type == 'free');

    });
  }
  displayPaymentButtons(){
this.displayButtons=true;
this.stripeService.elements(this.elementsOptions)
.subscribe(elements => {
  this.elements = elements;
  // Only mount the element the first time

  this.card = this.elements.create('card', {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        lineHeight: '40px',
        fontWeight: 300,
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
         name:'Card number',
          color: '#CFD7E0'
        }
      }
    }
  });
  this.card.mount('#card-element');

});
  }

  Cancel(){
    this.showplandetails=false;
    this.displayButtons=false;
  }
  displayDetails(data){
    this.showplandetails=true;
    this.selectedPlan = data;
   
  }

  paypalpay(data) {
    
    console.log(data)
   
    // this.showplandetails=true;
    this.selectedPlan = data;
    this.paymodal = true;
    if (data.user_type == "collaborator") {
      this.collaboratorid = this.userID;
      this.initiatorid = 0;
    }
    else {
      this.collaboratorid = 0;
      this.initiatorid = this.userID;
    }
    this.days = data.num_of_days;
    this.addDate(this.days);
    this.amount = data.price;

    this.payvalue = data.price;
    if (data.user_type != 'free') {
      render({
        id: "#myPaypalButtons",
        currency: "USD",
        value: this.payvalue,
        onApprove: (details) => {
          console.log(details)
          this.loginService.showSuccess("Transaction successful", 'success');
          // alert("Transaction successful");
          const json = {
            id:this.subscriptionrowid,
            subscriptionplanid: this.selectedPlan.id,
            collaboratorid: this.collaboratorid,
            initiatorid: this.initiatorid,
            amount: this.amount,
            payableamount: this.amount,
            subscriptionid: details.id,
            billing: 'Paypal',
            subscriptionresponse: details,
            startdate: this.startdate,
            enddate: this.enddate
          }

          this.loginService.SaveSubscriptions(json).subscribe(data => {
            console.log(data)
            if(data['_body'].toString()=="1"){
              this.loginService.GetAllUsers().subscribe(data => {

                data = JSON.parse(data['_body']);
                this.usersList = JSON.parse(JSON.stringify(data));
    
                this.currentUser = this.usersList.filter(x => x.id == this.userID);
    console.log(this.currentUser)
                let username = this.currentUser[0].user_name
                let email = this.currentUser[0].email
                const jsonData = {
                  usernameparm: username,
                  emailparm: email,
                  useridparm: this.userID,
                  issubscribedparam: "y"
                };
                this.loginService.SaveUsers(jsonData).subscribe(data => {
    
                });
              })
              if(this.currentUser[0].profilestatus=='n'){
              this.router.navigate(['/profilesetup', this.userID, this.tabvalue]);
              }
              else{
                if(this.tabvalue==1){
                  this.router.navigate(['/initatorcollabo', 0, 0]);
                }
                else if(this.tabvalue==2){
                  this.router.navigate(['/collabo']);
                }
              }
            }
          })
       
         
        }
      })
    }
    else {
      const json = {
        id:this.subscriptionrowid,
        subscriptionplanid: this.selectedPlan.id,
        collaboratorid: this.collaboratorid,
        initiatorid: this.initiatorid,
        amount: this.amount,
        payableamount: this.amount,
        subscriptionid: this.selectedPlan.id,
        billing: 'Paypal',
        subscriptionresponse: 'true',
        startdate: this.startdate,
        enddate: this.enddate
      }

      this.loginService.SaveSubscriptions(json).subscribe(data => {
console.log(data)
if(data['_body'].toString()=="1"){
  this.loginService.GetUsers(1).subscribe(data => {

    data = JSON.parse(data['_body']);
    this.usersList = JSON.parse(JSON.stringify(data));

    this.currentUser = this.usersList.filter(x => x.id == this.userID);
console.log(this.currentUser[0])
    let username = this.currentUser[0].user_name
    let email = this.currentUser[0].email
    const jsonData = {
      usernameparm: username,
      emailparm: email,
      useridparm: this.userID,
      issubscribedparam: "y"
    };
    this.loginService.SaveUsers(jsonData).subscribe(data => {

    });
  })

  if(this.currentUser[0].profilestatus=='n'){
    this.router.navigate(['/profilesetup', this.userID, this.tabvalue]);
    }
    else{
      if(this.tabvalue==1){
        this.router.navigate(['/initatorcollabo', 0, 0]);
      }
      else if(this.tabvalue==2){
        this.router.navigate(['/collabo']);
      }
    }
}
      })
     
      


    }

  }

  buyStripe() {
    const name = this.stripeTest.get('name').value;

    if (this.selectedPlan.user_type == "collaborator") {
      this.collaboratorid = this.userID;
      this.initiatorid = 0;
    }
    else {
      this.collaboratorid = 0;
      this.initiatorid = this.userID;
    }
    this.days = this.selectedPlan.num_of_days;
    this.addDate(this.days);
    this.amount = this.selectedPlan.price;
    this.stripeService
      .createToken(this.card, { name })
      .subscribe(obj => {
        if (obj) {

          this.http.post("http://localhost:3000/payme", {
            token: obj.token.id,
            name: name,
            amount: this.amount * 100
          }).subscribe(
            (res) => {
              console.log(res)
              this.loginService.showSuccess("Transaction successful", 'success');
              // alert("Payment successfull");
              const json = {
                id:this.subscriptionrowid,
                subscriptionplanid: this.selectedPlan.id,
                collaboratorid: this.collaboratorid,
                initiatorid: this.initiatorid,
                amount: this.amount,
                payableamount: this.amount,
                subscriptionid: obj.token.id,
                billing: 'Stripe',
                subscriptionresponse: res,
                startdate: this.startdate,
                enddate: this.enddate
              }

              this.loginService.SaveSubscriptions(json).subscribe(data => {
                console.log(data)
                if(data['_body'].toString()=="1"){
                  this.loginService.GetUsers(1).subscribe(data => {

                    data = JSON.parse(data['_body']);
                    this.usersList = JSON.parse(JSON.stringify(data));
    
                    this.currentUser = this.usersList.filter(x => x.id == this.userID);
    
                    let username = this.currentUser[0].user_name
                    let email = this.currentUser[0].email
                    const jsonData = {
                      usernameparm: username,
                      emailparm: email,
                      useridparm: this.userID,
                      issubscribedparam: "y"
                    };
                    this.loginService.SaveUsers(jsonData).subscribe(data => {
    
                    });
                  })
                  if(this.currentUser[0].profilestatus=='n'){
                    this.router.navigate(['/profilesetup', this.userID, this.tabvalue]);
                    }
                    else{
                      if(this.tabvalue==1){
                        this.router.navigate(['/initatorcollabo', 0, 0]);
                      }
                      else if(this.tabvalue==2){
                        this.router.navigate(['/collabo']);
                      }
                    }
    
                }
              })
             
              // this.router.navigateByUrl('/initatorhead/initatorcollabo');
            },
            (err) => {
              console.log('The error is ', err)
            })


        } else {
          // Error creating the token
          console.log("Error comes ");
        }
      });
  }

  
  Goback() {
    this.paystripe = false;
  }

  payStripe() {
    var handler = (<any>window).StripeCheckout.configure({
      key: 'pk_test_51J8LqISITWWOerdHC12yr8TiDQzeiE7gJKKRaVmFnJ0ub9GtQHwvtl1CrWWM5fx4wc7bGsPFRRvt1Zr69WXBPswY00CUi4Mxzm',
      locale: 'auto',
      token: function (token: any) {
        // You can access the token ID with `token.id`.
        // Get the token ID to your server-side code for use.

        alert('Token Created!!');
        this.dismissModal = true;

        // this.router.navigate(['/initatorcollabo']);
      }

    });

    handler.open({
      name: 'Cloud Collabo',
      description: 'Stripe payment',
      amount: this.amount * 100
    });
    // this.router.navigateByUrl('/initatorhead/initatorcollabo');

  }
}
